import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from 'projects/Administration/src/app/business-entities/brand.model';
import { PartNumberlist } from 'projects/Administration/src/app/business-entities/dealer-special-tool-view-model';
import { SelectListItemViewModel } from 'projects/Administration/src/app/business-entities/select-list-item-view-model';
import { DealerSpecialToolBusinessService } from 'projects/Administration/src/app/business-services/dealer-special-tool.service';
import { RentalCarService } from 'projects/Administration/src/app/business-services/rental-car.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
@Component({
  selector: 'app-add-dealer-special-tool',
  templateUrl: './add-dealer-special-tool.component.html'
})
export class AddDealerSpecialToolComponent implements OnInit {
  addSpecialTool = false;
  addSpecialToolForm: FormGroup;
  dealerList: Array<SelectListItemViewModel>;
  availableDealers: Array<SelectListItemViewModel>;
  brandList: Brand[] = [];
  brand: Brand[];
  partNumberList: PartNumberlist[] = [];
  partNumber: PartNumberlist[] = [];
  totalpartNumber: PartNumberlist[] = [];
  brandId: number;
  validate: boolean = false;
  SelectedDealer: string[]= [];
  constructor(
    private formBuilder: FormBuilder,
    private service: RentalCarService,
    private dealerSpecialtoolService: DealerSpecialToolBusinessService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private userService: UserDataService,
    private activeModal : NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.addSpecialToolForm = this.formBuilder.group({
      dealerName: [null, [Validators.required]],
      brand: [null, [Validators.required]],
      partNumber: [null, [Validators.required]],
      isActive: [true],
      totalPartQuantity: ['', [Validators.required]],
    });
    this.addSpecialToolForm.get('partNumber').disable();
    this.addSpecialToolForm.get('dealerName').disable();
    this.dealerList = this.dealerSpecialtoolService.dealerList;
    if(this.dealerList && this.dealerList.length == 1){
      this.SelectedDealer[0] = this.dealerList[0].text.toString();
      this.addSpecialToolForm.patchValue({
        dealerName: this.SelectedDealer
      })
    }
    this.GetAllBrand();
  }

  get cpf() {
    return this.addSpecialToolForm.controls;
  }

  async GetAllBrand() {
    await this.service.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  getPartNumber(code: string) {
    if(code == undefined){
      this.partNumber = [];
      this.totalpartNumber = [];
      this.addSpecialToolForm.get('partNumber').disable();
      return;
    }
    this.addSpecialToolForm.get('partNumber').enable();
    this.partNumber = [];
    this.totalpartNumber = [];
    let id = this.brand.find(f=>f.brandCode == code).id;
    this.dealerSpecialtoolService.GetDealerSpecialToolByBrandId(id).then(data => {
      this.partNumberList = data;
      const distinctThings = this.partNumberList.filter(
        (thing, i, arr) => arr.findIndex(t => t.partNumber === thing.partNumber) === i
      );
      for (let value of distinctThings) {
        this.partNumber.push(value)
      }
      for (let value of this.partNumberList) {
        this.totalpartNumber.push(value)
      }
    })

  }
  getDealerList() {
    if(this.dealerList && this.dealerList.length == 1){
      this.SelectedDealer[0] = this.dealerList[0].text.toString();
      this.addSpecialToolForm.patchValue({
        dealerName: this.SelectedDealer
      })
    }
    else{
      this.addSpecialToolForm.get('dealerName').enable();
      let specialtoolId = this.partNumber.find(x => x.partNumber === this.addSpecialToolForm.get('partNumber').value).id;
      let notAvailabledealers = this.totalpartNumber.filter(part => part.id == specialtoolId).map(part => part.dealerId);
      this.availableDealers = this.dealerList.filter(dealer => notAvailabledealers.findIndex(x => x == dealer.value) === -1);
    }
   }
  assignDealerSpecialTool() {
    let dealerId;
    let currentUser = this.userService.currentUserValue.id;
    if(this.dealerList && this.dealerList.length == 1){
       dealerId = this.dealerList[0].value;
    }
    else{
      dealerId = this.SelectedDealer.toString();
    }
    let viewModel =
    {
      SpecialToolId: this.partNumber.find(x => x.partNumber === this.addSpecialToolForm.get('partNumber').value).id,
      Quntity: this.addSpecialToolForm.get('totalPartQuantity').value,
      DealerId: dealerId,
      IsActive: this.addSpecialToolForm.get('isActive').value,
      CreateBy: currentUser
    }
    this.dealerSpecialtoolService.AssignDealerSpecialTool(viewModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        let successmsg = this.translate.instant("lblDealerSpecialToolUpdated");
        this.activeModal.close({ success: true });
        this.toastr.success(successmsg);
        this.spinner.hide();
      }
      else if (res.responseObject === false) {
        this.spinner.hide();
        let errormsg = this.translate.instant("lblDealerSpecialToolExist");
        this.toastr.warning(errormsg);
      }
    });
  }
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }
}
